import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Modal,
  TextField,
  Typography,
} from '@mui/material';
import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import styles from '../../styles';
import {claimShopifySubscription} from '../../api/shopifySubscriptionAPI';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  profileId: number;
  onSuccess: () => void;
}

const ShopifyMembershipClaimModal: React.FC<Props> = ({
  open,
  setOpen,
  profileId,
  onSuccess,
}) => {
  const {t} = useTranslation();

  const [shopifySubscriptionCode, setShopifySubscriptionCode] =
    useState<string>('');
  const [shopifySubscriptionApiLoading, setShopifySubscriptionApiLoading] =
    useState<boolean>(false);
  const [shopifySubscriptionError, setShopifySubscriptionError] =
    useState<string>('');

  const onClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={styles.modal}>
        <Box sx={{display: 'flex', flexDirection: 'column'}}>
          <Typography variant="h4" sx={{mb: 2}}>
            {t('membership.enterMembershipKey')}
          </Typography>
        </Box>
        <TextField
          label={t('membership.membershipKey')}
          sx={{width: '100%', mb: 3}}
          onChange={e => setShopifySubscriptionCode(e.target.value)}
          value={shopifySubscriptionCode}
        />
        {shopifySubscriptionError.length > 0 && (
          <Alert severity="error" variant="outlined" sx={{mb: 2}}>
            {shopifySubscriptionError}
          </Alert>
        )}
        <Box sx={{textAlign: 'right'}}>
          <Button
            variant="contained"
            disabled={
              shopifySubscriptionCode.length !== 36 ||
              shopifySubscriptionApiLoading
            }
            onClick={async () => {
              setShopifySubscriptionApiLoading(true);
              const res = await claimShopifySubscription({
                code: shopifySubscriptionCode,
                profileId,
              });
              if (res?.error) {
                setShopifySubscriptionApiLoading(false);
                setShopifySubscriptionError(res?.error);
              } else {
                setShopifySubscriptionError('');
                setShopifySubscriptionApiLoading(false);
                onClose();
                // fetch profile again
                onSuccess();
              }
            }}>
            {t('general.submit')}
            {shopifySubscriptionApiLoading ? (
              <CircularProgress sx={{color: '#fff', ml: 1}} size={16} />
            ) : null}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ShopifyMembershipClaimModal;
